import * as types from '../actions/actionTypes';

const initialState = {    
    printing: {
        loading: false,
        success: true,
        printerId: '',
        data: []
    },
    confirmPrinting: {
        loading: false,
        success: true
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_PRINT_CHECKS:
            return Object.assign({}, state, { printing: { ...state.printing, loading: true, printerId: action.printerId } });
        case types.PRINT_CHECKS_COMPLETED:
            return Object.assign({}, state, { printing: { ...state.printing, ...action.response } });

        case types.START_CONFIRM_CHECKS_PRINTED:
            return Object.assign({}, state, { confirmPrinting: { ...state.confirmPrinting, loading: true } });
        case types.CONFIRM_CHECKS_PRINTED:
            return Object.assign({}, state, { confirmPrinting: { ...state.confirmPrinting, ...action.response } });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/CheckPrintingReducer.js